import React, { useContext, useEffect, useState } from 'react';
import { useShowColums, useShowColumsHook } from '../../hooks/useShowColums';
import { headTbl, Tbltareas } from '../../data/tables';
import { AuthContext } from '../../auth/AuthContext';
import { useContextInfo } from '../../context/ContextInfo';
import { useGetDta } from '../../hooks/useGetDta';
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import LoadinSpin from '../ui/LoadinSpin';
import DropDownsCol from '../ui/DropDownsCol';
import classNames from 'classnames';
import Table from '../Table';
import ModTarea from './ModTarea';
import moment from 'moment';
import Confirmation from '../ui/Confirmation';
import { getInitialColumns } from '../../data/cards';
import CanvasTarea from './CanvasTarea';

const ListTareasTbl = ({ accesos }) => {
    const initialColums = getInitialColumns('tareas', Tbltareas);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'tareas');

    const { todo_new, todo_del } = accesos;
    const [estate, setEstado] = useState(0);

    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [showd, setShowd] = useState(false);
    const [item, setItem] = useState();
    const [info, setInfo] = useState({});
    const [info2, setInfo2] = useState({});
    const { loading, data, getInfo } = useGetDta(`tareas`, { estado: `all`, fecha: '', estate }, 'PUT');

    useEffect(() => {
        getInfo(`tareas`, { estado: `OTRO`, fecha: '', estate }, 'PUT');
    }, [estate]);
    const ActionColumn = ({ row }) => {
        return (
            <>
                {todo_del && (
                    <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">Borrar</Tooltip>}>
                        <i className="mdi mdi-delete mdi-18px " onClick={() => dele(row.original.id_tarea)}></i>
                    </OverlayTrigger>
                )}

                <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">Ver</Tooltip>}>
                    <i
                        className="mdi mdi-eye mdi-18px "
                        onClick={() => {
                            setInfo2(row.original);
                            setShow2(true);
                        }}></i>
                </OverlayTrigger>
                <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">Editar</Tooltip>}>
                    <i
                        className="mdi mdi-pencil mdi-18px "
                        onClick={() => {
                            setItem(row.original);
                            setShow(true);
                        }}></i>
                </OverlayTrigger>
            </>
        );
    };
    const dele = (id) => {
        setInfo({ id, type: 'TAREA' });
        setShowd(true);
    };
    const StatusColm = ({ row }) => {
        return (
            <span
                className={classNames('badge', {
                    'bg-danger': row.original.estado === 0, // Pendiente
                    'bg-info': row.original.estado === 1, //recorrido
                    'bg-warning': row.original.estado === 2, // En Progreso
                    'bg-dark': row.original.estado === 3, // No Completada
                    'bg-success': row.original.estado === 4, // Completado
                })}>
                {row.original?.estado === 0
                    ? 'PENDIENTE'
                    : row.original?.estado === 4
                    ? 'COMPLETADO'
                    : row.original?.estado === 2
                    ? 'EN PROGRESO'
                    : row.original?.estado === 1
                    ? 'EMPEZO RECCORIDO'
                    : row.original?.estado === 3
                    ? 'REAGENDADO'
                    : 'DESCONOCIDO'}
            </span>
        );
    };

    const PreColumn = ({ value }) => {
        return <div style={{ whiteSpace: 'pre-line' }}>{value}</div>;
    };
    const columns = [
        {
            Header: 'Id',
            accessor: 'id_tarea',
            sort: true,
        },
        {
            Header: 'Fecha reg.',
            accessor: 'fecha',
            sort: true,
            Cell: ({ value }) => <>{moment(value).format('YYYY-MM-DD HH:mm:ss')}</>,
        },

        {
            Header: 'Tarea',
            accessor: 'tarea',
            sort: true,
            Cell: ({ value }) => <PreColumn value={value} />,
        },

        {
            Header: 'Lider',
            accessor: 'lider',
            sort: true,
        },
        {
            Header: 'Ayudantes',
            accessor: 'ayudantes',
            sort: true,
        },

       
        {
            Header: 'nota',
            accessor: 'nota',
            sort: true,
            Cell: ({ value }) => <PreColumn value={value} />,
        },
        {
            Header: 'Estado',
            accessor: 'estado',
            sort: true,
            Cell: StatusColm,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    if (loading) return <LoadinSpin />;
    return (
        <div className="mt-3">
            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                columnasVisibles={columnasVisibles}
                isSearchable={true}
                searchBoxClass="mb-2"
                customButton={
                    todo_new && (
                        <Button
                            type="button"
                            onClick={() => {
                                setShow(true);
                                setItem({});
                            }}>
                            <b>+</b> Nuevo
                        </Button>
                    )
                }
                visiblesCustum={
                    <div className="d-flex">
                        <Form.Group className="mb-3 d-flex" controlId="validationCustom0">
                            <Form.Label className="mx-1 mt-1">Estado</Form.Label>
                            <Form.Select value={estate} required onChange={(e) => setEstado(e.target.value)}>
                                <option value="">Todos </option>
                                <option value={0}>Pendiente</option>
                                <option value={4}>Completada</option>
                                {/* <option value={2}>En progreso</option> */}
                                {/* <option value={3}>Reagendado</option> */}
                            </Form.Select>
                        </Form.Group>
                        <DropDownsCol
                            cols={columnasVisibles} // Pasar el estado desde TblZonas
                            toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                        />
                    </div>
                }
            />
            <CanvasTarea data={info2} show={show2} toggle={() => setShow2(false)} />

            <ModTarea show={show} callBk={getInfo} onClose={() => setShow(false)} item={item} />
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />
        </div>
    );
};
export default ListTareasTbl;
